<p-panel [header]="title">
  <p-card>
    <div class="grid-12">
      <!-- Our bank account. Absent where no money moves — see bankAccountControl. -->
      @if (bankAccountControl; as bankAccount) {
        <div class="span-12">
          <div class="form-box">
            <label>{{ 'BankCharges_BankAccount' | translateWF: 'Bank account' }} <span class="text-red-500">*</span></label>
            <p-select
              [formControl]="bankAccount"
              [options]="bankAccountOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              styleClass="w-full"
              [placeholder]="bankAccountPlaceholder"
              [ngClass]="{ 'ng-invalid ng-dirty': bankAccount.invalid && bankAccount.touched }"
            />
            @if (bankAccountOptions.length === 0) {
              <small class="text-surface-500">{{ noBankHint }}</small>
            }
          </div>
        </div>
      }

      <!-- Provider destination (#5143) — only where there is one to choose -->
      @if (destinationControl) {
        <div class="span-12">
          <div class="form-box">
            <label>{{ 'BankCharges_Destination' | translateWF: 'Destination (provider account)' }}</label>
            <p-select
              [formControl]="destinationControl"
              [options]="destinationOptions"
              optionLabel="label"
              optionValue="value"
              [readonly]="destinationReadonly"
              [showClear]="!destinationReadonly"
              appendTo="body"
              styleClass="w-full"
              [placeholder]="destinationPlaceholder"
            />
            @if (destinationOptions.length === 0) {
              <small class="text-amber-600">{{ noDestinationHint }}</small>
            } @else if (destinationHint) {
              <small class="text-surface-500">{{ destinationHint }}</small>
            }
          </div>
        </div>

        <!-- Whatever the host screen needs directly under the two accounts. Projected rather than built in:
             the vendor advance puts its exchange rate here, because the rate is a consequence of which two
             accounts were picked and reads as nonsense anywhere else — but that is the advance's business,
             not this component's, and every other caller projects nothing and is unchanged. -->
        <div class="span-12">
          <ng-content select="[destinationFooter]" />
        </div>
      }

      <!-- Bank reference. Absent for the same reason: there is no transfer to carry one. -->
      @if (referenceControl; as reference) {
        <div class="span-12">
          <div class="form-box">
            <label>{{ 'BankCharges_Reference' | translateWF: 'Bank transaction reference' }}</label>
            <span class="p-input-icon-left w-full">
              <i class="pi pi-hashtag"></i>
              <input pInputText [formControl]="reference" class="w-full" [placeholder]="referencePlaceholder" />
            </span>
            <small class="text-surface-500">{{ referenceHint }}</small>
          </div>
        </div>
      }

      <!-- Charges -->
      @if (bankingFeeControl) {
        <div class="span-12-6">
          <div class="form-box">
            <label>{{ 'BankCharges_BankingFee' | translateWF: 'Banking fee' }}</label>
            <p-inputNumber
              [formControl]="bankingFeeControl"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [min]="0"
              styleClass="w-full"
              [suffix]="' ' + currencyLabel"
            />
            <small class="text-surface-500">{{ bankingFeeHint }}</small>
          </div>
        </div>
      }
      @if (securityFeeControl) {
        <div class="span-12-6">
          <div class="form-box">
            <label>{{ 'BankCharges_SecurityFee' | translateWF: 'Security fee' }}</label>
            <p-inputNumber
              [formControl]="securityFeeControl"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [min]="0"
              styleClass="w-full"
              [suffix]="' ' + currencyLabel"
            />
            <small class="text-surface-500">{{ securityFeeHint }}</small>
          </div>
        </div>
      }
    </div>

    <!-- Attachments -->
    <p-panel header="{{ 'BankCharges_Attachments' | translateWF: 'Attachments' }}" class="bank-charges__attachments">
      @if (canAttach) {
        <label class="dropzone" [class.dropzone--dragging]="isDragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
          <input #fileInput type="file" class="hidden" [accept]="accept" (change)="onFile($event, fileInput)" />
          <i class="pi pi-cloud-upload"></i>
          <span class="dropzone__title"
            >{{ 'BankCharges_Upload' | translateWF: 'Click to upload' }} <em>{{ 'BankCharges_Upload_Drag' | translateWF: 'or drag and drop' }}</em></span
          >
          <span class="dropzone__hint">{{
            'BankCharges_Upload_Types'
              | translateWF
                : 'PDF, PNG, JPG, XLSX or DOCX · up to
          10
          MB each'
          }}</span>
        </label>
      } @else {
        <small class="text-surface-500">{{
          'BankCharges_Upload_SaveFirst'
            | translateWF
              : 'Save the draft first to attach
        documents.'
        }}</small>
      }

      @if (attachments.length > 0) {
        <ul class="attachment-list">
          @for (att of attachments; track att.name) {
            <li>
              <button type="button" class="attachment-link" (click)="attachmentOpened.emit(att.presignedUrl)">
                <i class="pi pi-file"></i>
                <span>{{ fileName(att.name) }}</span>
              </button>
            </li>
          }
        </ul>
      }
      <ng-template pTemplate="footer">
        <span>{{
          'BankCharges_Attachments_Hint'
            | translateWF
              : 'Receipts, wire confirmations,
          remittance advice'
        }}</span>
      </ng-template>
    </p-panel>
  </p-card>
</p-panel>
